import { createSlice } from '@reduxjs/toolkit'

const initialCoursesState = {
	listLoading: false,
	actionsLoading: false,
	totalCount: 0,
	entities: [],
	profiles: [],
	departments: [],
	courseForEdit: undefined,
	lastError: null,
}
export const callTypes = {
	list: 'list',
	action: 'action',
}

export const coursesSlice = createSlice({
	name: 'courses',
	initialState: initialCoursesState,
	reducers: {
		catchError: (state, action) => {
			state.error = `${action.payload.error}`
			if (action.payload.callType === callTypes.list) {
				state.listLoading = false
			} else {
				state.actionsLoading = false
			}
		},
		startCall: (state, action) => {
			state.error = null
			if (action.payload.callType === callTypes.list) {
				state.listLoading = true
			} else {
				state.actionsLoading = true
			}
		},
		// getCourseById
		courseFetched: (state, action) => {
			state.actionsLoading = false
			state.courseForEdit = action.payload.data
			state.error = null
		},
		// findCourses
		coursesFetched: (state, action) => {
			const { totalCount, entities } = action.payload
			state.listLoading = false
			state.error = null
			state.entities = entities
			state.totalCount = totalCount
		},
		// findCourses
		profilesFetched: (state, action) => {
			state.listLoading = false
			state.error = null
			state.profiles = action.payload
		},
		// findCourses
		departmentsFetched: (state, action) => {
			state.listLoading = false
			state.error = null
			state.departments = action.payload
		},
		// createCourse
		courseCreated: (state, action) => {
			state.actionsLoading = false
			state.error = null
			state.entities.push(action.payload.data)
		},
		// updateCourse
		courseUpdated: (state, action) => {
			state.error = null
			state.actionsLoading = false
			state.entities = state.entities.map((entity) => {
				if (entity.id === action.payload.course.id) {
					return action.payload.course
				}
				return entity
			})
		},
		// deleteCourse
		courseDeleted: (state, action) => {
			state.error = null
			state.actionsLoading = false
			state.entities = state.entities.filter(
				(el) => el.id !== action.payload.id
			)
		},
		// deleteCourses
		coursesDeleted: (state, action) => {
			state.error = null
			state.actionsLoading = false
			state.entities = state.entities.filter(
				(el) => !action.payload.ids.includes(el.id)
			)
		},
		// coursesUpdateState
		coursesStatusUpdated: (state, action) => {
			state.actionsLoading = false
			state.error = null
			const { ids, status } = action.payload
			state.entities = state.entities.map((entity) => {
				if (ids.findIndex((id) => id === entity.id) > -1) {
					entity.status = status
				}
				return entity
			})
		},
		// coursesUpdateState
		attended: (state, action) => {
			state.actionsLoading = false
			state.error = null
			const { id, data } = action.payload
			state.entities = state.entities.map((entity) => {
				if (Number(id) === entity.id) {
					entity = {
						...entity,
						link: data.link,
						link_details: data.link_details,
						status: true,
					}
				}
				return entity
			})
		},
		signedOut: (state, action) => {
			state.actionsLoading = false
			state.error = null
			const { id, data } = action.payload
			state.entities = state.entities.map((entity) => {
				if (Number(id) === entity.id) {
					entity = {
						...entity,
						attendance: {
							...entity.attendance,
							sign_out_time: data.sign_out_time,
						},
					}
				}
				return entity
			})
		},
		// courseUpdateState
		courseStatusUpdated: (state, action) => {
			state.actionsLoading = false
			state.error = null
			const { status } = action.payload
			state.courseForEdit.status = status
		},
	},
})
